<div class="title-dialog">
    <p class="title">Plan Details</p>
    <div class="close" (click)="dialogRef.close()">&#x2715;</div>
</div>
    
    <!-- <div class="description" [innerHTML]="planDescription"> -->
    <div class="plan-description">
        <div class="plan-description-container">
            <div class="plan-description-title">- Plan Duration</div>
            <div class="plan-description-value">{{planDescription['PlanDuration']}}</div>
        </div>
        <div class="plan-description-container">
            <div class="plan-description-title">- Plan Tier</div>
            <div class="plan-description-value">{{planDescription['PlanTierName']}}</div>
        </div>
        <div class="plan-description-container">
            <div class="plan-description-title">- Plan Payment Type</div>
            <div class="plan-description-value">{{planDescription['PlanPaymentTypeName']}}</div>
        </div>
    </div>
<!-- </div> -->